<template>
  <div>
    <p v-if="diferent">{{ errorConfirm }}</p>
    <p v-if="size">{{ error6 }}</p>
    <p v-if="error">
      {{ errorToken }}
    </p>
    <div v-else-if="notChanged">
      <label for="fname"> {{ newPwd }} </label><br />
      <div class="psw">
        <input id="psw" v-model="password" type="password" />
        <img v-if="!show" src="./eye.jpg" class="image" @click="showPsw()" />
        <img v-if="show" src="./noeye.jpg" class="image" @click="showPsw()" />
      </div>
      <br /><br />
      <label for="lname">{{ confirmPwd }} </label><br />

      <div class="psw">
        <input id="psw2" v-model="confirm" type="password" />
        <img v-if="!show2" src="./eye.jpg" class="image" @click="showPsw2()" />
        <img v-if="show2" src="./noeye.jpg" class="image" @click="showPsw2()" />
      </div>

      <!-- <input v-model="confirm" type="password" /> -->
      <br /><br />
      <button class="btn" :disabled="busy" @click="sendPsw()">
        <span v-if="!busy">{{ send }}</span>
        <div v-else class="loader"></div>
      </button>
    </div>
    <div v-else>
      <p>{{ success }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

/* eslint-disable */
export default {
  name: 'Form',
  components: {
    //
  },
  data() {
    return {
      notChanged: true,
      busy: false,
      password: '',
      confirm: '',
      show: false,
      show2: false,
      diferent: false,
      size: false,
      error: false,
      errorConfirm: 'Erro: senha e confirmação de senha não confere.',
      error6: 'Sua senha precisar ter pelo menos 6 caracteres.',
      errorToken:
        'Erro ao alterar senha! Requisite novamente no aplicativo uma nova mudança de senha para receber um link atualizado.',
      newPwd: 'Nova Senha',
      confirmPwd: 'Confirmar Senha',
      send: 'Enviar',
      success: 'Senha alterada com sucesso!',
      // url: 'http://localhost:3000/auth/email/reset-password/',
      url: 'https://guru-api.tramontina.com/auth/email/reset-password/',
    }
  },
  beforeDestroy: function() {
    //
  },
  mounted: function() {
    let information = window.location.href
    information = information.split('/')
    information = information[information.length - 1].split('-')
    let lang = information[2]
    if (lang == 'en') {
      this.errorConfirm = 'Error! Password and confirmation do not match.'
      this.error6 = 'Invalid password. Minimum of 6 digits.'
      this.errorToken =
        'There was an error changing your password! Request a new password in the app to try again.'
      this.newPwd = 'New Password'
      this.confirmPwd = 'Confirm password'
      ;(this.send = 'Update pasword'), (this.success = 'Password changed successfully!')
    } else if (lang == 'es') {
      this.errorConfirm = 'Error! La contraseña y la confirmación no coinciden.'
      this.error6 = 'Contraseña invalida. Mínimo de 6 dígitos.'
      this.errorToken =
        '¡Hubo un error al cambiar su contraseña! Solicite una nueva contraseña en la aplicación para volver a intentarlo.'
      this.newPwd = 'Nueva contraseña'
      this.confirmPwd = 'Confirmar la contraseña'
      this.send = 'Actualizar la contraseña'
      this.success = '¡Contraseña alterada con éxito!'
    } else {
      this.errorConfirm = 'Erro! Senha e confirmação não conferem.'
      this.error6 = 'Senha inválida. Mínimo de 6 dígitos.'
      this.errorToken =
        'Ocorreu um erro ao alterar a sua senha! Solicite uma nova senha no aplicativo para tentar novamente.'
      this.newPwd = 'Nova Senha'
      this.confirmPwd = 'Confirmar Senha'
      ;(this.send = 'Atualizar senha'), (this.success = 'Senha alterada com sucesso!')
    }
  },

  methods: {
    async sendPsw() {
      this.diferent = false
      this.size = false
      this.error = false
      let information = window.location.href
      information = information.split('/')
      information = information[information.length - 1].split('-')
      let token = information[0]
      let email = information[1]
      if (
        this.password == this.confirm &&
        this.password != '' &&
        this.password.length > 5 &&
        token &&
        email
      ) {
        let body = {
          email: email,
          newPassword: this.password,
          newPasswordToken: token,
        }
        this.busy = true
        const resp = await axios.post(this.url, body).finally(() => {
          this.busy = false
        })
        // console.log(resp)
        // console.log(resp.data.success)
        if (resp.data.success == true) {
          alert(this.success)
          this.notChanged = false
        } else {
          this.error = true
        }
      } else {
        if (this.password != this.confirm) this.diferent = true
        if (this.password.length < 6) this.size = true
      }
    },

    showPsw() {
      this.show = !this.show
      if (this.show) {
        document.getElementById('psw').type = 'text'
      } else {
        document.getElementById('psw').type = 'password'
      }
    },

    showPsw2() {
      this.show2 = !this.show2
      if (this.show) {
        document.getElementById('psw2').type = 'text'
      } else {
        document.getElementById('psw2').type = 'password'
      }
    },
  },
}
</script>

<style>
input {
  text-align: center;
  border: none !important;
  border-style: none !important;
  height: 30px !important;
  position: absolute !important;
  left: 4% !important;
  top: 0px !important;
  width: 80% !important;
}

.psw {
  /* width: 150px;
  height: 30px; */
  position: relative;
  border-radius: 30px;
  border-color: rgb(225, 225, 225);
  outline: none;
  border-style: solid;
  padding: 5px;
  height: 30px;
}

.image {
  position: absolute;
  right: 10px;
  height: 30px;
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid rgb(243, 182, 123); /* Blue */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
